"use strict";

require("./404");
require("./agent");
require("./almond");
require("./auction");
require("./back-top");
require("./banner");
require("./battery");
require("./box");
require("./bug");
require("./building");
require("./chart");
require("./clipboard");
require("./component");
require("./dashboard");
require("./discount");
require("./documentation");
require("./drag");
require("./edit");
require("./education");
require("./email");
require("./example");
require("./excel");
require("./exit-fullscreen");
require("./eye-off");
require("./eye-on");
require("./faq");
require("./form");
require("./fullscreen");
require("./globe");
require("./guide-2");
require("./guide");
require("./hamburger");
require("./icon");
require("./inr");
require("./international");
require("./language");
require("./like");
require("./link");
require("./list");
require("./location");
require("./lock");
require("./lost");
require("./message");
require("./missed-followup");
require("./money");
require("./nested");
require("./new-contacts1");
require("./no-followup");
require("./open-inquiries");
require("./password");
require("./pdf");
require("./people");
require("./peoples");
require("./presentation-sent");
require("./puzzle");
require("./qq");
require("./quotation-sent");
require("./riyal");
require("./sack");
require("./sample-sent");
require("./scale");
require("./search");
require("./series");
require("./shopping");
require("./size");
require("./skill");
require("./star");
require("./support");
require("./tab");
require("./table");
require("./tag");
require("./tax");
require("./theme");
require("./total-inquiries");
require("./tree-table");
require("./tree");
require("./trophy");
require("./truck");
require("./user");
require("./wechat");
require("./won");
require("./zip");